import { StringUtils } from '@/common/utils/StringUtils';
import { far, fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const LEVEL_CONFIG = {
  TRACE: { label: 'Trace', color: 'cyan', icon: far.faInfoCircle },
  DEBUG: { label: 'Debug', color: 'blue', icon: far.faInfoCircle },
  INFO: { label: 'Informational', color: 'green', icon: far.faInfoCircle },
  WARN: { label: 'Warning', color: 'orange', icon: fas.faExclamationTriangle },
  ERROR: { label: 'Error', color: 'red', icon: fas.faExclamationTriangle },
};

export const LoggerEffectiveCellRenderer = ({ value }) => {
  if (!value) return <span />;

  const config = LEVEL_CONFIG[value];
  if (!config) {
    return <span>{StringUtils.toUpperCamel(value)}</span>;
  }

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
      <FontAwesomeIcon icon={config.icon} color={config.color} />
      <span>{config.label}</span>
    </span>
  );
};
